import './styles/WaitScreen.scss';
import { AppContext } from '../Context';
import { System_DeviceOrientationMap } from '../assets/keyMap';
import { useState, useEffect, useRef, useContext } from 'react';

interface Props {
    message: string,
    shouldShowWaitScreen: boolean
}

const WaitScreen:React.FC<Props> = ({message, shouldShowWaitScreen}) => {
    //contexts
    const appContext = useContext(AppContext);
    //state
    const [currentMessage, SetCurrentMessage] = useState('. . ' + message + ' . .');
    //ref
    const currentMessageRef = useRef(currentMessage);
    const messageTextAnimIntervalRef = useRef<any>(null);
    const messageRef = useRef(message);

    useEffect(() => {
        SetCurrentMessage('. . ' + message + ' . .');
        currentMessageRef.current = '. . ' + message + ' . .';
        messageRef.current = message;
    }, [message]);

    useEffect(() => {
        if(shouldShowWaitScreen) {
            messageTextAnimIntervalRef.current = setInterval(() => {
                switch(currentMessageRef.current) {
                    default:
                    case '. . ' +  messageRef.current + ' . .':
                        currentMessageRef.current = '    ' +  messageRef.current + '    ';
                    break;
                    case '    ' +  messageRef.current + '    ':
                        currentMessageRef.current = '  . ' +  messageRef.current + ' .  ';
                    break;
                    case '  . ' +  messageRef.current + ' .  ':
                        currentMessageRef.current = '. . ' +  messageRef.current + ' . .';
                    break;
                }
                SetCurrentMessage(currentMessageRef.current);
            }, 300);
        } else {
            clearInterval(messageTextAnimIntervalRef.current!);
        }
        return(() => {
            clearInterval(messageTextAnimIntervalRef.current!);
        });
    }, [shouldShowWaitScreen]);

    return(
        <div className={'WaitScreen ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait' ) + ' ' + (!shouldShowWaitScreen ? 'hide': '')}>
            <span className='WaitScreen-message'>
                {currentMessage}
            </span>
        </div>
    );
}
export default WaitScreen;